export const imageError = {
  de: 'Image too large. Please select different image.',
  en: 'Image too large. Please select different image.',
  sv: 'Bilden är för stor. Välj en annan bild.',
};
